var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('img',{attrs:{"src":"https://resource.tuixb.cn/test/mp_73fdb0e0-56b0-11ea-910e-792184e2a553/default/1b59efcd-458c-4858-8f51-33c20145ab7c.png","alt":""}}),_c('div',{staticClass:"text_cont"},[_vm._v("您购买的站点已到期")]),_c('div',{staticClass:"text_cont"},[_vm._v("如需恢复正常使用，请拨打客服热线续费")])])
}]

export { render, staticRenderFns }